import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class OrganizationCompactEntity extends Entity {
    constructor() {
        super(...arguments);
        this.abbreviation = null;
        this.id = 0;
        this.licensedUsersCount = null;
        this.licenseExpirationDTTM = null;
        this.name = null;
        this.organizationStatusId = null;
        this.organizationStatusName = null;
        this.organizationTypeId = 0;
        this.organizationTypeName = null;
        this.totalLicenses = null;
        this.usersCount = null;
    }
    pk() {
        return this.id.toString();
    }
}
OrganizationCompactEntity.schema = {
    licenseExpirationDTTM: ISODate
};
OrganizationCompactEntity.key = 'OrganizationCompact';
export { OrganizationCompactEntity };
